// React
import React from 'react';
// External
import { Form } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import SelectSearch from 'react-select-search';
import { BsChevronDown } from 'react-icons/bs';
import { BsInfoCircle } from 'react-icons/bs';
import isEmpty from 'lodash/isEmpty';
// Styles
import './styles.scss';

/**
 * @param {Object} props.className - Class to be applied to the button
 * @param {Object} props.controlClassName - Class to be applied to the button
 * @param {Array} props.options - Options to be displayed in the selector
 */
class ProductSelector extends React.Component {
    constructor(props) {
        super(props);
        let initialValue = this.props.label ? this.props.label : '';
        let shouldChangeAutomatically = false;
        let optionSelected;
        let count

        if (this.props.value) {
            optionSelected = props.options.find((option) => option.value === this.props.value);
            if (optionSelected) {
                initialValue = optionSelected.name;
                shouldChangeAutomatically = true;
            }
        }

        this.selectorRef = React.createRef();
        this.bOpenOptions = false;
        this.bEnterPressed = false;

        this.state = {
            count: 0,
            label: initialValue,
            hasError: this.props.hasError ? this.props.hasError : ''
        };

        if (shouldChangeAutomatically) {
            this.props.onChange(this.props.value, optionSelected);
        }
    }
    
    componentDidUpdate(prevProps) {
        if (this.props.type !== 'Package') {
            if (prevProps.value !== this.props.value || prevProps.hasError !== this.props.hasError) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({ hasError: this.props.hasError });
                if (!this.state.label && this.props.value) {
                    const optionSelected = this.props.options.find((option) => option.value === this.props.value);

                    if (optionSelected) {
                        this.setState({ label: optionSelected.name });
                    }
                }
            }

            // Updates the value initially set if the options change
            if (prevProps.value === this.props.value && prevProps.options !== this.props.options) {
                const optionSelected = this.props.options.find((option) => option.value === this.props.value);
                if (optionSelected) {
                    this.setState({ label: this.state.label });
                }
            } else if (prevProps.value && !this.props.value) {
                this.setState({ label: this.props.label ? this.props.label : '' });
            }  else {
                if (prevProps.value !== this.props.value) {
                    const optionSelected = this.props.options.find((option) => option.value === this.props.value);
                    if (optionSelected) {
                        this.setState({ label: optionSelected.name });
                    }
                }
            }

        } else {
            this.state.count  = this.state.count + 1
        }
    }

    onChange(value, obj) {
        this.setState({ label: obj.name, hasError: false });
        this.props.onChange(value, obj);

        // If the enter key is pressed, set it back to false and then focus back to the dropdown
        if (this.bEnterPressed) {
            this.bEnterPressed = false;
            setTimeout(() => this.selectorRef.current.querySelector('input').focus(), 50);
        }
    }

    defaultValue(value, obj) {
        this.setState({ label: obj.name, hasError: false });
        this.props.defaultValue(value, obj);
    }

    render() {
        let selectedValue = !isEmpty(this.props.currentOption) ? this.props.currentOption.find(x => x.value === this.props.value) : ''
        let isSpecialOrder = !isEmpty(selectedValue) ? selectedValue.isSpecialOrder : ''
            return (
                <div>
                       <div className="selector">
                    <SelectSearch
                        ref={this.selectorRef}
                        className={this.props.className}
                        options={this.props.options ? this.props.options : []}
                        onChange={(value, obj) => { this.onChange(value, obj); }}
                        value={this.props.value}
                        renderValue={(valueProps) => (
                            <Form.Control
                                {...valueProps}
                                className={this.props.hasError && this.props.isSubmitted ? 'is-invalid' : ''}
                                name={this.props.name}
                                type="text"
                                placeholder={this.props.placeholder}
                                onMouseDownCapture={objEvent => {
                                    this.bOpenOptions = true;
                                }}
                                onFocusCapture={objEvent => {
                                    if (!this.bOpenOptions) {
                                        objEvent.stopPropagation();
                                    } else {
                                        this.bOpenOptions = false;
                                    }
                                }}
                                onKeyDownCapture={objEvent => {
                                    if (objEvent.key === 'Tab') {
                                        try {
                                            // Get the currently highlighted option and use it as the selected value
                                            const value = objEvent.target.parentElement.parentElement.parentElement.querySelector('.is-highlighted').value;
                                            
                                            this.onChange(value, { name: value });
                                        } catch(objError) {
                                            console.log('Error in selecting product options: ', objError);
                                        }
                                    }

                                    // If the enter key is pressed, set the flag to true and then set the open options flag to false
                                    if (objEvent.key === 'Enter') {
                                        this.bOpenOptions = false;
                                        this.bEnterPressed = true;
                                    }

                                    // If the arrow up or down is pressed, open the options
                                    if (objEvent.key === 'ArrowUp' || objEvent.key === 'ArrowDown') {
                                        this.selectorRef.current.querySelector('input').blur();

                                        this.bOpenOptions = true;            

                                        this.selectorRef.current.querySelector('input').focus();
                                    }
                                }}
                            />
                        )}
                    />
                    {this.props.hasDownIcon ? 
                        <BsChevronDown onClick={() => {
                            this.bOpenOptions = true;
                            this.selectorRef.current.querySelector('input').focus();
                        }}/> : ''
                    }
                </div>
                    {
                    isSpecialOrder ? 
                    <div class="popover__wrapper">
                        <div>
                            <div class={this.props.infoIconClass}><BsInfoCircle /></div>
                        </div>
                        <div class="popover__content">
                            <div class="popover__message">
                                <h4>Special order product</h4>
                                <p class="border-line">Please allow 4 - 6 weeks for this item.</p>
                            </div>
                        </div>
                    </div> : ''
                    }       
                </div>
                
            );
    }
}

export default withRouter(ProductSelector);
